import React from "react";
import { motion } from "framer-motion";
import {
  Sparkles, FileText, GraduationCap, ClipboardCheck, Stamp, Home, HeartPulse,
  Landmark, Plane, LifeBuoy, Languages, Users, Wallet, PiggyBank,
} from "lucide-react";

const services = [
  { icon: Sparkles, label: "University matching" },
  { icon: FileText, label: "Application assistance" },
  { icon: GraduationCap, label: "Admissions guidance" },
  { icon: ClipboardCheck, label: "Document review" },
  { icon: Stamp, label: "Visa support" },
  { icon: Home, label: "Housing search" },
  { icon: HeartPulse, label: "Health insurance guidance" },
  { icon: Landmark, label: "Banking setup" },
  { icon: Plane, label: "Travel preparation" },
  { icon: LifeBuoy, label: "Arrival support" },
  { icon: Languages, label: "French language resources" },
  { icon: Users, label: "Student life guidance" },
  { icon: PiggyBank, label: "Scholarship resources" },
  { icon: Wallet, label: "Budget planning" },
];

export default function ServicesGrid() {
  return (
    <section className="bg-[#f5f1e8] py-24 md:py-32" data-testid="services-grid">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8">
          <span className="rule-gold" /><span className="eyebrow">What we do</span>
        </div>
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <h2 className="md:col-span-8 serif text-5xl md:text-6xl leading-[0.98] tracking-tight text-[#0d1b3e]">
            Fourteen services, <em className="italic text-[#b8892b]">one journey</em>.
          </h2>
          <p className="md:col-span-4 text-lg text-[#4a5570] leading-relaxed">
            From your first university shortlist to your first Sunday grocery run, everything you need is inside FrancePath.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {services.map(({ icon: Icon, label }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 7) * 0.04 }}
              className="bg-white border border-[#0d1b3e]/10 p-4 md:p-5 hover:border-[#b8892b] transition-colors flex flex-col gap-3"
              data-testid={`service-${i}`}
            >
              <div className="w-8 h-8 bg-[#0d1b3e] text-[#b8892b] flex items-center justify-center">
                <Icon size={14} />
              </div>
              <div className="text-[13px] text-[#0d1b3e] leading-snug font-medium">{label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
